import { render, staticRenderFns } from "./EditSessionModal.vue?vue&type=template&id=21476944&scoped=true"
import script from "./EditSessionModal.vue?vue&type=script&lang=js"
export * from "./EditSessionModal.vue?vue&type=script&lang=js"
import style0 from "./EditSessionModal.vue?vue&type=style&index=0&id=21476944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21476944",
  null
  
)

export default component.exports